module.exports = __webpack_public_path__ + "static/media/default_job_avatar.827e8254.png";